import React, { FC } from "react";

import {
  useApisMembersEmployeeSurveySubmissionsLikedEmployeesIndex,
  useArray,
} from "~/hooks";

import { ReactedEmployeesModal } from "~/components/molecules";

import { ReactedEmployeeType } from "~/domains";

type PropsType = {
  employeeSurveySubmissionId: string;
  onClose: () => void;
};

export const EmployeeSurveySubmissionsLikedEmployeesModal: FC<PropsType> = ({
  employeeSurveySubmissionId,
  onClose,
}: PropsType) => {
  const { items, setItems } = useArray<ReactedEmployeeType>([]);
  const { fetchNextPage, hasNextPage, isLoading } =
    useApisMembersEmployeeSurveySubmissionsLikedEmployeesIndex({
      employeeSurveySubmissionId,
      config: {
        onSuccess: (data) => {
          setItems(
            data.pages.map((page) => page.employeeSurveySubmissionLikes).flat(),
          );
        },
      },
    });
  return (
    <ReactedEmployeesModal
      headerTitle="いいねしたユーザー"
      onClose={onClose}
      reactedEmployees={items}
      nextFetchFunction={fetchNextPage}
      hasMore={hasNextPage}
      isLoading={isLoading}
    />
  );
};
